import clsx from "clsx";

import { FLOW_TYPE_OPTIONS } from "../../constants";

import type { CampaignFlowType } from "../../types";

export default function FlowTypeLabel({
  type,
  isDisabled = false,
}: {
  type: CampaignFlowType;
  isDisabled?: boolean;
}) {
  const { icon: Icon, classNames } = FLOW_TYPE_OPTIONS[type];

  return (
    <span
      className={clsx(
        "inline-flex size-12 shrink-0 items-center justify-center rounded-3xl",
        isDisabled ? "bg-black-200 text-black-400" : classNames,
      )}
    >
      <Icon size={24} />
    </span>
  );
}
